// extracted by mini-css-extract-plugin
export default {"card":"MissionSection_card__zIhP6"};